// src/pages/MS/MSR101F1.jsx
import React, {useEffect, useState} from 'react';

import DataGrid from "../../components/DataGrid/DataGrid";

import style from "./MSR101F1.module.scss";
import {postData} from "../../utils/TransactionUtil";
import Icon from "../../components/Icon/Icon";
import SelectBox from "../../components/SelectBox/SelectBox";
import Button from "../../components/Button/Button";


const ButtonFormatter = ({ row }) => {
    if(row.modInfo) {
        return (
            <button title={row.modInfo}>
                <Icon id="edit_01" width="16" height="17"/>
            </button>
        );
    }
    return null;
};


const MSR101F1 = ({navBar: NavBar}) => {

    //역할 리스트
    const [rows_RoleList, setRows_RoleList] = useState([]);
    const cols_RoleList = [
        { key: 'st',         name: '상태',      width: '10%', sortable:'true' },
        { key: 'sqnc',       name: 'NO',        width: '10%', renderCell: ({ rowIdx }) => rowIdx+1 },
        { key: 'roleNm',     name: '역할명',     width: '30%', cellClass: 'align_left' },
        { key: 'roleDscr',   name: '역할설명',   width: '30%', cellClass: 'align_left' },
        { key: 'roleUseYn',  name: '사용여부',   width: '10%', },
        { key: 'modInfo',    name: '수정정보',   width: '10%', renderCell: ButtonFormatter}
    ];

    //역할_메뉴 리스트
    const [rows_RoleMenuList, setRows_RoleMenuList] = useState([]);
    const cols_RoleMenuList = [
        { key: 'st',            name: '상태',        width: '5%', sortable:'true' },
        { key: 'sqnc',          name: 'NO',         width: '10%', renderCell: ({ rowIdx }) => rowIdx+1 },
        { key: 'menuLevel',     name: '메뉴레벨',     width: '15%'},
        { key: 'menuNm',        name: '메뉴명',      width: '70%'},
    ];

    useEffect(() => {

        getRoleList(); //롤 그룹을 조회 함

    }, []);

    //그룹코드 row 클릭
    const handleClick_RoleList = (e) => {
        getRoleMenuList(e.row,e.column.key).then(() => {});
    }

    //롤 그룹을 조회
    async function getRoleList(){
        let param = {

        }

        const res = await postData("/MSR/getRoleList", param);
        setRows_RoleList(res);
    }

    //공통 코드 상세 조회
    async function getRoleMenuList(row, key){
        let param = {
            roleId : row.roleId
        }

        const res = await postData("/MSR/getRoleMenuList", param);
        setRows_RoleMenuList(res);
    }

    return(
        <main className={style.main_wrap}>
            <NavBar>
                {/*검색영역*/}
                <div className={style.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "58px", height: "40px"}}>
                        저장
                    </Button>
                </div>
            </NavBar>
            {/*내용*/}
             <div className={style.main_cont}>
                 <div className={style.cont_item}>
                    <div className={style.info_grp}>
                        <h3>역할</h3><label>[총 <span>{rows_RoleList.length}건</span> ]</label>
                        <div className={style.btn_grp}>
                            <Button variant="Secondary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                추가 <Icon id="plus_01" width="16" height="16"/>
                            </Button>
                            <Button variant="Tertiary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                삭제 <Icon id="minus_01" width="16" height="16"/>
                            </Button>
                        </div>
                    </div>
                     <div className={style.grad_wrap}>
                         <DataGrid
                             cols={cols_RoleList}
                             rows={rows_RoleList}
                             size='md'
                             headerRowHeight={37}
                             rowHeight={37}
                             onCellClick={(e) => handleClick_RoleList(e)}
                         />
                     </div>
                 </div>
                 <div className={style.cont_item}>
                    <div className={style.info_grp}>
                        <h3>메뉴</h3><label>[총 <span>{rows_RoleMenuList.length}건</span> ]</label>
                        <div className={style.btn_grp}>
                            <Button variant="Secondary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                추가 <Icon id="plus_01" width="16" height="16"/>
                            </Button>
                            <Button variant="Tertiary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                삭제 <Icon id="minus_01" width="16" height="16"/>
                            </Button>
                        </div>
                    </div>
                     <div className={style.grad_wrap}>
                         <DataGrid
                             cols={cols_RoleMenuList}
                             rows={rows_RoleMenuList}
                             size='md'
                             headerRowHeight={37}
                             rowHeight={37}
                             //onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                         />
                     </div>
                 </div>
             </div>
        </main>
    )
}
export default MSR101F1;
